module.exports = __webpack_public_path__ + "static/img/icon_vip1.847ca2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_vip1.png
// module id = Hdag
// module chunks = 192